import { useMemo } from 'react'
import type { LabelGroupDocument } from '@/lib/db/rxdb/schemas/labelGroup'
import { useLabelGroups as useRxDBLabelGroups } from '@/lib/db/rxdb/hooks'

export function useLabelGroups(
  workspaceId: string | null | undefined,
  projectId?: string | null | undefined,
) {
  const { labelGroups: allLabelGroups, isLoading } = useRxDBLabelGroups()

  const labelGroups = useMemo(() => {
    if (!workspaceId) {
      return []
    }

    return allLabelGroups
      .filter((group: LabelGroupDocument) => {
        if (group.envId !== workspaceId) {
          return false
        }

        if (projectId !== undefined) {
          return group.projectId === projectId
        }

        return !group.projectId
      })
      .sort((a: LabelGroupDocument, b: LabelGroupDocument) => {
        const aOrder = a.sortOrder ?? ''
        const bOrder = b.sortOrder ?? ''
        if (aOrder && bOrder) {
          return aOrder.localeCompare(bOrder)
        }
        if (aOrder || bOrder) {
          return aOrder ? -1 : 1
        }
        return a.name.localeCompare(b.name)
      })
  }, [workspaceId, projectId, allLabelGroups])

  return {
    labelGroups,
    isLoading,
  }
}

export function useAllLabelGroups(
  workspaceId: string | null | undefined,
) {
  const { labelGroups: allLabelGroups, isLoading } = useRxDBLabelGroups()

  const labelGroups = useMemo(() => {
    if (!workspaceId) {
      return []
    }

    return allLabelGroups
      .filter(
        (group: LabelGroupDocument) =>
          group.envId === workspaceId,
      )
      .sort((a: LabelGroupDocument, b: LabelGroupDocument) => {
        const aOrder = a.sortOrder ?? ''
        const bOrder = b.sortOrder ?? ''
        if (aOrder && bOrder) {
          return aOrder.localeCompare(bOrder)
        }
        if (aOrder || bOrder) {
          return aOrder ? -1 : 1
        }
        return a.name.localeCompare(b.name)
      })
  }, [workspaceId, allLabelGroups])

  return {
    labelGroups,
    isLoading,
  }
}
